module.exports = __webpack_public_path__ + "img/pro_03.b2e8b918.jpg";